module.exports = __webpack_public_path__ + "media/images/icons/soundcloud-52742b140f8fb3164a057bf03cfad3f4.svg";